import { createFileRoute } from "@tanstack/react-router";
import SpravatoForTreatmentResistantDepression from "@/pages/SpravatoForTreatmentResistantDepression";
export const Route = createFileRoute(
  "/spravato-for-treatment-resistant-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Spravato For Treatment Resistant Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO for treatment-resistant depression in Coral Springs, FL. Learn how esketamine nasal spray works when antidepressants haven’t helped.",
        },
        {
          property: "og:title",
          content:
            "Spravato For Treatment Resistant Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO for treatment-resistant depression in Coral Springs, FL. Learn how esketamine nasal spray works when antidepressants haven’t helped.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/spravato-for-treatment-resistant-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-for-treatment-resistant-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoForTreatmentResistantDepression />;
}
